<ng-template #template let-row="row">
  <div
    class="project-name-cell no-select d-none d-md-flex"
    [ngClass]="{ 'project-name-cell--favourited': row.isFavourite }"
  >
    <!-- <svg-icon
      [src]="'/assets/img/ic-star-filled.svg'"
      [svgStyle]="{ width: '18px', height: '18px' }"
      (click)="setFavourite(row)"
    /> -->
    <a
      draggable="false"
      [class.disabled]="!row?.accessToPreview || row?.deleted"
      [class.grey-1]="!row?.accessToPreview || row?.deleted"
      [routerLink]="n.getPath('project-dashboard-summary', {}, { projectId: row?.id })"
      [matTooltip]="row?.name || ''"
      matTooltipPosition="above"
      matTooltipShowDelay="1000"
    >
      {{ row?.name }}
    </a>
  </div>

  <div class="project-name-cell d-md-none" [ngClass]="{ 'project-name-cell--favourited': row.isFavourite }">
    <!-- <svg-icon
      [src]="'/assets/img/ic-star-filled.svg'"
      [svgStyle]="{ width: '24px', height: '24px' }"
      (click)="setFavourite(row)"
      class="no-select"
    /> -->
    <div class="project-name-cell_title">
      <div class="grey-1 mb-2" *ngIf="row?.fullAddress">
        <b class="ellipsis-1">{{ row?.fullAddress }}</b>
      </div>
      <div class="grey-4 ellipsis-1">
        {{
          row?.basicDataBox?.mainContact?.mainContact?.fullName
            ? row?.basicDataBox?.mainContact?.mainContact?.fullName + ', '
            : ''
        }}
        {{ row.name }}
      </div>
    </div>
  </div>
</ng-template>
